import RootLayout from "@/components/Ui/Tools/RootLayout/RootLayout";
import { baseURL, MEDIA_URL } from "@/services/api";
import { ICategory, ICategoryGeneric } from "global-types/global.types";
import { GetStaticProps } from "next";
import Head from "next/head";
import styled from "styled-components";
import OrderFollowEpty from "@/assets/img/orderFollowEmpty.svg";
import Link from "next/link";
import FavoriteBg from "@/assets/img/favorite.png";
import userOrderFollow from "@/hooks/pages/order-follow/userOrderFollow";
import { ChangeEvent, FormEvent, useState } from "react";
import { useRouter } from "next/router";
import { SITE_NAME } from "@/helper/constant";

interface Props {
  locale: string;
}

export default function Privacy({ locale }: Props) {
  const [params, setParams] = useState<{
    id: string;
  }>({
    id: "",
  });

  const { data, mutateOrderFollow, isLoading } = userOrderFollow();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;

    setParams({
      id: value,
    });
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    mutateOrderFollow(params);
  };

  const { push } = useRouter();

  return (
    <>
      <Head>
        <title> {"Order follow" + " | " + SITE_NAME}</title>
      </Head>
      <Wrapper>
        <div className="order-follow">
          <div className="order-follow-header">
            <div className="info">
              <h1 className="title">Track the orders</h1>
              <p className="customer-code">Enter the ID number</p>
            </div>
          </div>
          <div className="order-follow-content">
            <form onSubmit={handleSubmit}>
              <input
                type="number"
                name="id"
                placeholder="Enter the ID number"
                value={params.id}
                onChange={handleChange}
              />

              <button className={`button`} type="button" onClick={handleSubmit}>
                Search
              </button>
            </form>

            <div className="order-follow-result">
              {!isLoading &&
                data?.data.items?.map((el, index) => (
                  <div className="order-details" key={`${el.id}-${index}`}>
                    <div className="img-container">
                      <img
                        src={`${MEDIA_URL}/${el.product?.image}`}
                        alt="product"
                      />
                    </div>
                    <div className="content">
                      <div className="ordered-product">
                        <Link href={`/product-detail/${el.product?.slug}`}>
                          <p className="product-name">{el.product?.title}</p>
                        </Link>
                        <p className="product-count">
                          <span className="quantity"> {el.quantity} Unit</span>
                          <svg
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 1L1 7"
                              stroke="#989EAF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M1 1L7 7"
                              stroke="#989EAF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>

                          <span className="price">
                            {el.price}
                            <svg
                              className="manatIcon"
                              width={33}
                              height={27}
                              viewBox="0 0 33 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M15 26L15.8511 1.03704L18.6596 0L19 24L15 26Z"
                                fill="#FF4C4C"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0 26.7126L3.31441 26.8563C3.37837 10.7044 12.0742 5.37873 16.3559 5.22923C27.9253 5.59751 29.2515 20.3484 29.6856 26.8563L33 27C32.7507 11.4088 24.1817 2.85531 17.1485 3.00185C5.15613 3.42337 0.588832 15.6295 0 26.7126Z"
                                fill="#FF4C4C"
                              />
                            </svg>
                          </span>
                        </p>
                      </div>
                      <div className="other-info">
                        <button className="status">{el.status?.title}</button>
                        {el.status?.title?.toLowerCase() === "Approved" ? (
                          <button className="write-comment" onClick={() => {}}>
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15 10.3333C15 10.7459 14.8361 11.1416 14.5444 11.4333C14.2527 11.725 13.857 11.8889 13.4444 11.8889H4.11111L1 15V2.55556C1 2.143 1.16389 1.74733 1.45561 1.45561C1.74733 1.16389 2.143 1 2.55556 1H13.4444C13.857 1 14.2527 1.16389 14.5444 1.45561C14.8361 1.74733 15 2.143 15 2.55556V10.3333Z"
                                stroke="#06BE87"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            Write comment
                          </button>
                        ) : (
                          <div style={{ width: "9.2rem", height: "20px" }} />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            {!isLoading && params.id !== "" && data?.data.items.length === 0 ? (
              <div className="order-follow-empty">
                <img src={OrderFollowEpty.src} />

                <h5>No result found</h5>
                <div>
                  Add products to basket or account for your previous orders{" "}
                  <Link href={`/${locale}/login`}>Login</Link>
                </div>
                <button
                  onClick={() => {
                    push({
                      pathname: `/${locale}/categories/gitara`,
                    });
                  }}
                >
                  Do Shopping
                </button>
              </div>
            ) : (
              <></>
            )}

            {/* {showCommentModal && <AddOrUpdateCommentModal id={commentId} />} */}
          </div>
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  min-height: calc(100vh - 400px);

  button {
    border: none;
  }

  .order-follow {
    width: 1128px;
    margin: 0 auto;
    margin-top: 2.4rem;
    margin-bottom: 300px;

    @media screen and (max-width: 1199px) {
      width: 100%;
      padding: 0 16px;
    }

    .breadcrumb {
      display: none;
    }

    .order-follow-header {
      background: url(${FavoriteBg.src});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      width: 100%;
      height: 27rem;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      padding: 2.4rem;
      margin-top: 24px;

      .breadcrumb {
        padding-top: 0 !important;
        display: block;

        a {
          color: #fff;
        }

        .breadcrumb-seperator {
          background-color: #fff;
        }
      }

      .info {
        .title {
          font-style: normal;
          font-weight: 600;
          font-size: 3.2rem;
          line-height: 100%;
          color: #ffffff;
          margin-bottom: 6px;
        }

        .customer-code {
          font-style: normal;
          font-weight: normal;
          font-size: 1.2rem;
          line-height: 125%;
          color: #fdfdfd;
        }
      }
    }

    .order-follow-content {
      width: 812px;
      margin: 0 auto;
      margin-top: 39px;

      form {
        display: flex;
        align-items: center;
        position: relative;

        input {
          width: 100%;
          background: rgba(208, 212, 222, 0.25);
          border-radius: 6px;
          height: 66px;
          padding: 0 24px;
          font-style: normal;
          font-weight: normal;
          font-size: 18px;
          line-height: 18px;
          color: #444444;
          border: none;
          outline: none;
        }

        button {
          font-family: "Nunito";
          font-style: normal;
          font-weight: normal;
          font-size: 20px;
          line-height: 100%;
          text-align: center;
          color: #ffffff;
          background: #ff4c4c;
          border-radius: 0px 6px 6px 0px;
          position: absolute;
          right: 0;
          top: 0%;
          height: 66px;
          width: 122px;
        }
      }

      .order-follow-result {
        margin-top: 36px;
      }

      .order-details {
        display: flex;
        align-items: center;
        padding: 2.4rem 0;
        border-bottom: 1px solid rgba($color: #d0d4de, $alpha: 0.25);

        &:first-child {
          padding-top: 0;
        }

        .img-container {
          background: #ffffff;
          box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.06);
          border-radius: 3px;
          width: 10rem;
          height: 10rem;
          margin-right: 2.4rem;

          img {
            border-radius: 3px;
            width: 10rem;
            height: 10rem;
            object-fit: contain;
          }
        }

        .content {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .ordered-product {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            .product-name {
              font-style: normal;
              font-weight: normal;
              font-size: 2rem;
              line-height: 125%;
              color: #3a4155;
              margin-bottom: 12px;
            }

            .product-count {
              .quantity {
                font-style: normal;
                font-weight: 300;
                font-size: 1.4rem;
                line-height: 125%;
                color: #3a4155;
              }

              svg {
                width: 6px;
                height: 6px;
                margin: 0 12px;
              }

              .price {
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 18px;
                color: #ff2459;

                .manatIcon {
                  width: 1.6rem;
                  height: 1.3rem;
                  margin: 0;
                }
              }
            }
          }

          .other-info {
            display: flex;
            align-items: center;

            .status {
              height: 4.2rem;
              background: #1b1c1f;
              // background: rgba($color: #2f80ed, $alpha: 0.25);
              border-radius: 3px;
              font-style: normal;
              font-weight: 500;
              font-size: 1.4rem;
              line-height: 125%;
              text-align: center;
              color: #ffffff !important;
              min-width: 12.2rem;
              margin-right: 2.4rem;
              cursor: pointer;
            }

            .write-comment {
              font-style: normal;
              font-weight: normal;
              font-size: 1.6rem;
              line-height: 125%;
              color: #06be87;
              display: flex;
              align-items: center;
              cursor: pointer;

              svg {
                margin-right: 12px;
              }
            }
          }
        }
      }
    }

    .order-follow-empty {
      background: rgba(208, 212, 222, 0.25);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 36px 16px;

      svg {
        margin-bottom: 24px;
      }

      h5 {
        font-style: normal;
        font-weight: normal;
        font-size: 32px;
        line-height: 32px;
        color: #1b1c1f;
        margin-bottom: 12px;
      }

      div {
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 16px;
        color: #444444;
        text-align: center;

        a {
          color: #ff4c4c;
        }
      }

      button {
        background: #ff4c4c;
        border-radius: 6px;
        width: 260px;
        height: 60px;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 24px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 36px;
      }
    }

    @media screen and (max-width: 991.9px) {
      .order-follow-content {
        width: 100%;
      }
    }

    @media screen and (max-width: 767.9px) {
      .breadcrumb {
        display: block;
      }

      .order-follow-header {
        height: 150px;
        justify-content: flex-end;
        width: 100vw;
        margin-left: -50vw;
        margin-right: -50vw !important;
        position: relative;
        left: 50%;
        right: 0;
        border-radius: 0;

        .breadcrumb {
          display: none;
        }

        .customer-code {
          font-size: 14px !important;
        }
      }

      .order-details {
        .img-container {
          min-width: 100px !important;
          min-height: 100px !important;
          margin-right: 12px !important;

          img {
            width: 100% !important;
            height: 100% !important;
            object-fit: cover !important;
          }
        }

        .content {
          display: flex;
          flex-direction: column;
          align-items: flex-start !important;

          .ordered-product {
            .product-name {
              font-size: 16px !important;
            }

            .product-count {
              margin-bottom: 12px;
            }
          }

          .status {
            height: 24px !important;
            font-size: 12px !important;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 24px;
            margin-right: 0;
          }
        }

        .other-info {
          display: flex;
          flex-direction: row-reverse;
        }
      }

      .order-follow-content form {
        margin-bottom: 24px;

        input {
          height: 50px;
          font-size: 16px;
          padding-left: 16px;
          padding-right: 100px;
        }

        button {
          height: 50px;
          font-size: 16px;
          width: 80px;
        }
      }

      .order-follow-empty {
        svg {
          width: 172px;
          height: 132px;
        }

        h5 {
          font-size: 24px;
          margin-bottom: 12px;
        }

        div {
          font-size: 16px;
          line-height: 125%;
        }

        button {
          margin-top: 24px;
          font-size: 20px;
          line-height: 20px;
          width: 100%;
          height: 50px;
        }
      }
    }
  }
`;
